<div class="box card-box" [ngClass]="!tableOnly ? 'm-x-sm' : 'p-t-md no-bg'">

  <div class="box-header" *ngIf="!tableOnly">
    <h3>{{'EVENT_LOG.events_log' | translate}}</h3>
  </div>

  <div [class.box-body]="!tableOnly" class="log-event-content">
    <gp-table class="table" (sortChange)="onSortKeyChange($event)" [fixedLayout]="false">
      <thead gp-table-head>
      <tr role="row">
        <th class="column-title text-muted small w-160"
            gp-table-column
            sort-key="createDate"
            default-sort="asc"
            scope="col">
          {{ 'COMMON.date' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column sort-key="level" scope="col">
          {{ 'EVENT_LOG.level' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column sort-key="eventType" scope="col">
          {{ 'COMMON.type' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column sort-key="category" scope="col">
          {{ 'COMMON.category' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column sort-key="message" scope="col">
          {{ 'COMMON.message' | translate }}
        </th>
        <th gp-table-column scope="col">
          <div class="pull-right">
            <div class="box-tool">
              <ul class="nav">
                <li>
                  <button
                    (click)="resetFilters()"
                    [disabled]="!isFiltering()"
                    class="btn btn-xs btn-outline-primary clear-filter">
                    {{ 'CONTEXT_BAR.clear_all_filters' | translate }}
                  </button>
                </li>
                <li class="nav-item inline">
                  <a class="nav-link" (click)="refresh()">
                    <i class="fa-solid fa-rotate"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </th>
      </tr>
      <tr class="row filters" [formGroup]="filtersForm">
        <td>
          <datepicker-input formControlName="createDate"></datepicker-input>
        </td>
        <td>
          <select class="form-control" formControlName="level">
            <option></option>
            <option *ngFor="let level of levels" [value]="level">
              {{ 'EVENT_LOG.level_' + level | translate }}
            </option>
          </select>
        </td>
        <td>
          <select class="form-control" formControlName="eventType">
            <option></option>
            <option *ngFor="let eventType of eventTypes" [value]="eventType">
              {{ 'EVENT_LOG.type_' + eventType | translate }}
            </option>
          </select>
        </td>
        <td>
          <input type="text" formControlName="category"
                 class="form-control b-a form-group-sm search-field"
                 (keydown.enter)="$event.preventDefault()">
        </td>
        <td colspan="2">
          <input type="text" formControlName="message"
                 class="form-control b-a form-group-sm search-field"
                 (keydown.enter)="$event.preventDefault()">
        </td>
      </tr>
      </thead>
      <tbody>
      <tr *ngIf="loading">
        <td colspan="11" class="text-center p-t-lg p-b-lg">
          <em class="fa fa-light fa-spinner fa-spin"></em>
        </td>
      </tr>

      <tr [ngClass]="{'last': log.last}" *ngFor="let log of events; let logIndex = index;">
        <td class="table-td-100">{{ log.createDate | gpDate:{withTime: true, timezone: timezone} }}</td>
        <td><span [ngClass]="'level_'  + log.level">{{ 'EVENT_LOG.level_' + log.level | translate | uppercase }}</span></td>
        <td>{{ 'EVENT_LOG.type_' + log.eventType | translate }}</td>
        <td>{{ log.category }}</td>
        <td>{{ log.message }}</td>
        <td colspan="2">
          <ng-container *ngIf="log.last && log.level === errorLevel && log.eventType !== technicalType">
            <div (mouseenter)="hoverByIndex[logIndex] = true"
                 (mouseleave)="hoverByIndex[logIndex] = false"
                 [attr.test-id]="'log-event-select-status' + logIndex">
              <select class="form-control"
                      [disabled]="isEventLogStatusReadOnly"
                      [ngModel]="log.status"
                      (change)="onChangeStatus(log, transformStatus(extractValue($event.target)))"
                      [popover]="logEventModifier"
                      [isOpen]="hoverByIndex[logIndex] && !!log.statusMetadata"
                      popoverTitle="{{log.statusMetadata?.lastUpdateAuthor}}"
                      placement="left"
                      triggers=""
                      container="body">
                <option [value]="null">-</option>
                <option *ngFor="let status of statuses" [value]="status">
                  {{ 'EVENT_LOG.status_' + status | translate }}
                </option>
              </select>
              <ng-template #logEventModifier>
                <div [attr.test-id]="'log-event-select-status-popover' + logIndex">
                  <div>{{ log.statusMetadata?.updateDate | gpDate: {withTime: true}: timezone }}</div>
                  <div>{{log.statusMetadata?.comment}}</div>
                </div>
              </ng-template>
            </div>

          </ng-container>
        </td>
      </tr>
      </tbody>
    </gp-table>
    <div *ngIf="!loading && events.length === 0">
      <gp-illustrated-message [text]="'EVENT_LOG.events_not_found'" [width]="'65%'"></gp-illustrated-message>
    </div>
  </div>

  <footer class="dker p-a" gp-sticky="bottom">
    <div class="row">
      <div class="col-sm-12 text-center">
        <ul class="pagination pagination-sm gp-pagination m-a-0" [class.gp-pagination-hidden]="!pagination.hasMultiplePages()">
          <li class="page-item" [ngClass]="{disabled: !pagination.hasPrevious()}">
            <a class="page-link" (click)="pagination.hasPrevious() && pagination.first()"><em
              class="fa fa-light fa-angle-double-left"></em></a>
          </li>
          <li class="page-item" [ngClass]="{disabled: !pagination.hasPrevious()}">
            <a class="page-link" (click)="pagination.hasPrevious() && pagination.previous()"><em
              class="fa fa-light fa-angle-left"></em></a>
          </li>
          <li *ngFor="let page of pagination.pages()" class="page-item"
              [ngClass]="{active: page === pagination.currentPage.number + 1, disabled: page < 1}">
            <a *ngIf="page > 0" class="page-link" (click)="pagination.goToPage(page - 1)">{{ page }}</a>
            <a *ngIf="page < 1" class="page-link default-cursor">…</a>
          </li>
          <li class="page-item" [ngClass]="{disabled: !pagination.hasNext()}">
            <a class="page-link" (click)="pagination.hasNext() && pagination.next()"><em
              class="fa fa-light fa-angle-right"></em></a>
          </li>
          <li class="page-item" [ngClass]="{disabled: !pagination.hasNext()}">
            <a class="page-link" (click)="pagination.hasNext() && pagination.last()"><em
              class="fa fa-light fa-angle-double-right"></em></a>
          </li>
        </ul>
      </div>
    </div>
  </footer>

</div>

<gp-modal gp-modal="logEventModification" #logEventModification
          test-id="log-event-modification-modal"
          [closable]="true">

  <div class="gp-modal-title">
    {{ 'EVENT_LOG_MODIFICATION.title' | translate }}
  </div>

  <form [formGroup]="logEventModificationForm" novalidate class="gp-modal-body clearfix">
    <div class="col-md-12">
      <div class="form-group">
        <label for="logEventModificationComment">{{ 'COMMON.comment' | translate }}
        </label>
        <div class="input-group">
          <input id="logEventModificationComment" formControlName="comment" type="text" class="form-control">
        </div>
      </div>
    </div>
  </form>

  <div class="gp-modal-footer">
    <button type="button"
            class="btn dark-white p-x-md"
            test-id="log-event-modification-modal-cancel"
            (click)="logEventModification.close()">
      {{'FORMS.cancel' | translate}}
    </button>
    <button type="submit"
            class="btn btn-dark p-x-md"
            test-id="log-event-modification-modal-submit"
            (click)="updateLogEvent()">
      {{ 'FORMS.submit' | translate }}
    </button>
  </div>
</gp-modal>
